import { isEmpty, isEqual } from 'lodash';

import { IGlobalProductEntity } from 'components/BusinessToolForm/Sections/Global/general/products';

import { IProductChangeType, PRODUCT_CHANGE_TYPE } from '../../utils/form';

export const productChangeType = (
  currentProductsArray: IGlobalProductEntity[],
  previousProductsArray: IGlobalProductEntity[],
): IProductChangeType => {
  if (isEmpty(currentProductsArray) && isEmpty(previousProductsArray)) return PRODUCT_CHANGE_TYPE.NO_CHANGE;

  if (currentProductsArray.length > previousProductsArray.length) {
    return PRODUCT_CHANGE_TYPE.ADD;
  } else if (currentProductsArray.length < previousProductsArray.length) {
    return PRODUCT_CHANGE_TYPE.REMOVE;
  } else {
    return PRODUCT_CHANGE_TYPE.UPDATE;
  }
};

export const getUpdatedProductData = (
  currentProductsArray: IGlobalProductEntity[],
  previousProductsArray: IGlobalProductEntity[] | null,
) => {
  if (!previousProductsArray) return null;
  return currentProductsArray.find((currentProduct, index) => {
    if (!isEqual(currentProduct, previousProductsArray[index])) {
      return true;
    }
  });
};
